<template>
  <p class="pager-wrapper" v-if="totalPage > 0">
    <span :class="{'disabled': currentPage === 1}" @click="go(currentPage - 1)">{{ $t('previous') }}</span>
    <span :class="{'current-page': currentPage === 1}" @click="go(1)">1</span>

    <span v-show="pages[0] > 2">···</span>
    <span :class="{'current-page': currentPage === page}" v-for="page in pages" @click="go(page)">{{ page }}</span>
    <span v-show="pages[pages.length - 1] < totalPage - 1">···</span>

    <span :class="{'current-page': currentPage === totalPage}" v-if="totalPage > 1"
          @click="go(totalPage)">{{ totalPage }}</span>
    <span @click="go(currentPage + 1)" :class="{'disabled': currentPage === totalPage}">{{ $t('next') }}</span>
  </p>
</template>

<script>
  import locales from './lang'

  /*
   * component pager 翻页页码组件
   */
  export default {
    props: {
      totalPage: { // 总页数
        type: Number,
        default: 0,
        required: true
      },
      showItems: { // 中间显示出来的页数个数，如: 1 ··· 34[5]67 ··· 10
        type: Number,
        default: 3
      },
      initPage: { // 初始化时加载的页码
        type: Number,
        default: 1
      },
      mode: {
        type: String,
        default: 'event' // 'event' | 'query' | 'params'
      },
      routeName: {
        type: String
      }
    },
    data() {
      return {
        currentPage: 0
      }
    },
    locales,
    created() {
      this.currentPage = this.initPage
      if (this.mode === 'params' && !this.routeName) {
        // throw 'need a route name when choose params mode in pager component'
      }
    },
    computed: {
      pages() {
        let getPages = (start, end) => {
          if (start <= 1 || start > end || start >= this.totalPage) {
            start = 2
          }
          if (end >= this.totalPage || end < start || end <= 1) {
            end = this.totalPage - 1
          }
          let arr = []
          for (let i = start; i <= end; i++) {
            arr.push(i)
          }
          return arr
        }

        let counts = this.showItems
        if (this.totalPage < counts + 2) {
          return getPages(2, this.totalPage - 1)
        } else {
          if (this.currentPage <= 1 + Math.ceil(counts / 2)) {
            return getPages(2, 2 + counts - 1)
          } else if (this.currentPage >= this.totalPage - Math.ceil(counts / 2)) {
            let end = this.totalPage - 1
            return getPages(end - (counts - 1), end)
          } else {
            let half = Math.floor(counts / 2)
            let end = this.currentPage + half
            return getPages(this.currentPage - half, end)
          }
        }
      }
    },
    methods: {
      go(page) {
        if (page === this.currentPage || page < 1 || page > this.totalPage) {
          return
        }
        this.currentPage = parseInt(page, 10)
        if (this.mode === 'query') {
          let query = this.$route.query
          query.page = this.currentPage
          this.$router.go({query: query})
        } else if (this.mode === 'params') {
          let params = this.$route.params
          params.page = this.currentPage
          this.$router.go({name: this.routeName, params: params})
        } else {
          this.$emit('go-page', {
            page: this.currentPage
          })
        }
      }
    },
    watch: {
      initPage(newVal) {
        if (this.currentPage !== newVal) {
          this.currentPage = newVal
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }
  .pager-wrapper {
    text-align: center;
  }
  span {
    font-size: .14rem;
    color: #999;
    letter-spacing: 0;
    margin: 0 .08rem;
    line-height: .22rem;
    cursor: pointer;
    display: inline-block;
    width: .24rem;
    height: .24rem;
    border-radius: 50%;
    border: 1px solid #E0D7E3;
    @media screen and (max-width: 767px) {
      margin: 0 .03rem;
    }
    &:first-child, &:last-child {
      display: inline;
    }
    &.current-page {
      color: #295FFD;
      border-color: #295FFD;
    }
    &:first-child, &:last-child {
      border: none;
      color: #333;
      &.disabled {
        color: #999;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?fd1ce6e2